import { Component, ContentChild, Directive, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GLOBAL_CONSTANTS } from 'app/constants';
import { NgRadio } from 'ng-radio';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[bpEditableLabelEditContent]'
})
export class EditableLabelEditContentDirective {
    constructor(public templateRef: TemplateRef<any>) {}
}

@Component({
    selector: 'bp-editable-label',
    templateUrl: './editable-label.component.html',
    styleUrls: ['./editable-label.scss']
})
export class EditableLabel implements OnInit, OnDestroy {
    @Input() form!: FormGroup;
    @Input() name!: string;
    @Input() placeholder: string = '';

    @ContentChild(EditableLabelEditContentDirective, { read: TemplateRef })
    injectedTemplate?: TemplateRef<any>;

    isEditing = false;

    private subscriptions = new Subscription();

    constructor(private radio: NgRadio) {}

    ngOnInit() {
        this.subscriptions.add(
            this.radio.on(GLOBAL_CONSTANTS.CHANNEL.APPLICATION.APPLICATION_UPDATED).subscribe(() => {
                this.isEditing = false;
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    toggleEdit() {
        this.isEditing = !this.isEditing;
    }

    get hasInjectedContent(): boolean {
        return !!this.injectedTemplate;
    }
}
